(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertising-product-section"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {

	var screenWidth = screen.width;
	var screenHeight = screen.height;

    var sync1 = $("#big");
    var sync2 = $("#thumbs");
    var slidesPerPage = 5; //globaly define number of elements per page
    var syncedSecondary = true;

	if(screenWidth < 480){
       slidesPerPage = 3;                
	}

    sync1.owlCarousel({
        items: 1,
        slideSpeed: 2000,
        nav: true,
        autoplay: false,
        autoHeight: true,                  
        dots: false,
        loop: true,
        responsiveRefreshRate: 200,
    }).on('changed.owl.carousel', syncPosition);
                          
    sync2.on('initialized.owl.carousel', function () {
        sync2.find(".owl-item").eq(0).addClass("current");
    })
    .owlCarousel({
        items: slidesPerPage,
        dots: false,
        nav: true,
        smartSpeed: 200,
        slideSpeed: 500, 
		autoHeight: true,
        slideBy: 2, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
        responsiveRefreshRate: 100,
		navText: [
            '<i class="fa fa-angle-left" aria-hidden="true"></i>',
            '<i class="fa fa-angle-right" aria-hidden="true"></i>'
        ],
    }).on('changed.owl.carousel', syncPosition2);

    function syncPosition(el) {
        //if you set loop to false, you have to restore this next line
        //var current = el.item.index;

        //if you disable loop you have to comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - (el.item.count / 2) - .5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }

        //end block

        sync2.find(".owl-item").removeClass("current").eq(current).addClass("current");
        var onscreen = sync2.find('.owl-item.active').length - 1;
        var start = sync2.find('.owl-item.active').first().index();
        var end = sync2.find('.owl-item.active').last().index();

        if (current > end) {
            sync2.data('owl.carousel').to(current, 100, true);
        }
        if (current < start) {
            sync2.data('owl.carousel').to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            sync1.data('owl.carousel').to(number, 100, true);
        }
    }

    sync2.on("click", ".owl-item", function (e) {
        e.preventDefault();
        var number = $(this).index();
        sync1.data('owl.carousel').to(number, 300, true);
    });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-customer-reviews"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
  window.setTimeout(function(){
     $('#home_cust_review').owlCarousel({
        loop:false,
        responsiveClass:true,
		center: false,
        onDragged: stopVideos,
		onDrag: stopVideos,
        responsive:{
            0:{
                items:1,
				navigation:false
            },
            480:{
                items:2,
                nav:false
            },
			767:{
                items:3,
                nav:false
            }
        }
    });
  });


});

function stopVideos(){
	$('.cust_play').attr('src', '');
	$('.cust_vid_overlay').show();
}


  } catch(e) { console.error(e); }
})();
})();
